import { render, staticRenderFns } from "./UpdatePricePopup.vue?vue&type=template&id=a44f166e"
import script from "./UpdatePricePopup.vue?vue&type=script&lang=js"
export * from "./UpdatePricePopup.vue?vue&type=script&lang=js"
import style0 from "./UpdatePricePopup.vue?vue&type=style&index=0&id=a44f166e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports